// import Vue from 'vue'
// import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: {
      name: 'list',
      query: {field: '全部', category: '全部'}
    }
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('@/components/list.vue'),
	meta: {
		metaInfo: {
		  title: "",
		  keywords: "",
		  description: ""
		  }
	}
  },
  {
    path: '/Inside',
    name: 'Inside',
    component: () => import('@/components/Inside.vue'),
	meta: {
		metaInfo: {
		  title: "",
		  keywords: "",
		  description: ""
		  }
	}
  }
]

const router = new VueRouter({
  routes
})

export default router
